import React, { useEffect, useState } from "react";
import {
  Col,
  Dropdown,
  DropdownMenu,
  DropdownToggle,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
} from "reactstrap";
import { Link } from "react-router-dom";
import classnames from "classnames";

//SimpleBar
import SimpleBar from "simplebar-react";
import { useDispatch, useSelector } from "react-redux";
import { getNotificationOpenList } from "../../store/actions";
import { isEmpty } from "lodash";
import { HandleDateTimeAgo as handleTimeAgo } from "../Common/HandleDateTimeAgo";

const NotificationDropdown = () => {
  const dispatch = useDispatch();
  //Dropdown Toggle
  // Redux State
  const { notificationOpenList } = useSelector((state) => ({
    notificationOpenList:
      state.Notification.notificationOpenList?.notification_list,
  }));

  // Local State
  const [isNotificationDropdown, setIsNotificationDropdown] = useState(false);
  const toggleNotificationDropdown = () => {
    setIsNotificationDropdown(!isNotificationDropdown);
  };

  //Tab
  const [activeTab, setActiveTab] = useState("1");
  const toggleTab = (tab) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
    }
  };

  useEffect(() => {
    dispatch(getNotificationOpenList());
  }, []);

  return (
    <React.Fragment>
      <Dropdown
        id={"#zbtn_header_annoucements"}
        isOpen={isNotificationDropdown}
        toggle={toggleNotificationDropdown}
        className="topbar-head-dropdown ms-1 header-item"
      >
        <DropdownToggle
          type="button"
          tag="button"
          className="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle"
        >
          <i className="bx bx-bell fs-22"></i>
          {isEmpty(notificationOpenList) ? null : (
            <span className="position-absolute topbar-badge fs-10 translate-middle badge rounded-pill bg-danger">
              {notificationOpenList?.length}
              <span className="visually-hidden">unread messages</span>
            </span>
          )}
        </DropdownToggle>
        <DropdownMenu className="dropdown-menu-lg dropdown-menu-end p-0">
          <div className="dropdown-head bg-primary bg-pattern rounded-top">
            <div className="p-3">
              <Row className="align-items-center">
                <Col>
                  <h6 className="m-0 fs-16 fw-semibold text-white">
                    {" "}
                    Notifications{" "}
                  </h6>
                </Col>
                <div className="col-auto dropdown-tabs">
                  <span className="badge badge-soft-light fs-13">
                    {" "}
                    {notificationOpenList?.length || 0} New
                  </span>
                </div>
              </Row>
            </div>

            <div className="px-2 pt-2">
              <Nav className="nav-tabs dropdown-tabs nav-tabs-custom">
                <NavItem>
                  <NavLink
                    href="#"
                    className={classnames({ active: activeTab === "1" })}
                    onClick={() => {
                      toggleTab("1");
                    }}
                  >
                    All ({notificationOpenList?.length || 0})
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    href="#"
                    className={classnames({ active: activeTab === "2" })}
                    onClick={() => {
                      toggleTab("2");
                    }}
                  >
                    Messages (
                    {notificationOpenList?.filter(
                      (item) => item.NotificationType_Id === "1"
                    )?.length || 0}
                    )
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    href="#"
                    className={classnames({ active: activeTab === "3" })}
                    onClick={() => {
                      toggleTab("3");
                    }}
                  >
                    Alerts (
                    {notificationOpenList?.filter(
                      (item) => item.NotificationType_Id === "2"
                    )?.length || 0}
                    )
                  </NavLink>
                </NavItem>
              </Nav>
            </div>
          </div>

          <TabContent activeTab={activeTab}>
            <TabPane tabId="1" className="py-2 ps-2">
              <SimpleBar
                style={{ maxHeight: "300px", minHeight: "100px" }}
                className="pe-2"
              >
                {!isEmpty(notificationOpenList) ? (
                  notificationOpenList?.map((item, index) => (
                    <div
                      key={index}
                      className="text-reset notification-item d-block dropdown-item"
                    >
                      <div className="d-flex">
                        <img
                          src={item?.ImageUrl}
                          className="me-3 rounded-circle avatar-xs"
                          alt="user-pic"
                        />
                        <div className="flex-1">
                          <Link to={item?.LinkUrl} className="stretched-link">
                            <h6 className="mt-0 mb-1 fs-13 fw-semibold">
                              {item?.Title}
                            </h6>
                          </Link>
                          <div className="fs-13 text-muted">
                            <p className="mb-1">{item?.Description}</p>
                          </div>
                          <p className="mb-0 fs-11 fw-medium text-uppercase text-muted">
                            <span>
                              <i className="mdi mdi-clock-outline"></i>{" "}
                              <span>
                                {handleTimeAgo(item?.CreatedDateTime)} ago
                              </span>
                            </span>
                          </p>
                        </div>
                        {/*<div className="px-2 fs-15">*/}
                        {/*  <div className="form-check notification-check">*/}
                        {/*    <input*/}
                        {/*      className="form-check-input"*/}
                        {/*      type="checkbox"*/}
                        {/*      value=""*/}
                        {/*      id="messages-notification-check01"*/}
                        {/*    />*/}
                        {/*    <label*/}
                        {/*      className="form-check-label"*/}
                        {/*      htmlFor="messages-notification-check01"*/}
                        {/*    ></label>*/}
                        {/*  </div>*/}
                        {/*</div>*/}
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="text-center">
                    <span>You have no notifications.</span>
                  </div>
                )}
              </SimpleBar>
            </TabPane>

            <TabPane tabId="2" className="py-2 ps-2">
              <SimpleBar style={{ maxHeight: "300px" }} className="pe-2">
                {!isEmpty(
                  notificationOpenList?.filter(
                    (item) => item.NotificationType_Id === "1"
                  )
                ) ? (
                  notificationOpenList
                    ?.filter((item) => item.NotificationType_Id === "1")
                    ?.map((item, index) => (
                      <div
                        key={index}
                        className="text-reset notification-item d-block dropdown-item"
                      >
                        <div className="d-flex">
                          <img
                            src={item?.ImageUrl}
                            className="me-3 rounded-circle avatar-xs"
                            alt="user-pic"
                          />
                          <div className="flex-1">
                            <Link to={item?.LinkUrl} className="stretched-link">
                              <h6 className="mt-0 mb-1 fs-13 fw-semibold">
                                {item?.Title}
                              </h6>
                            </Link>
                            <div className="fs-13 text-muted">
                              <p className="mb-1">{item?.Description}</p>
                            </div>
                            <p className="mb-0 fs-11 fw-medium text-uppercase text-muted">
                              <span>
                                <i className="mdi mdi-clock-outline"></i>{" "}
                                <span>
                                  {handleTimeAgo(item?.CreatedDateTime)} ago
                                </span>
                              </span>
                            </p>
                          </div>
                          {/*<div className="px-2 fs-15">*/}
                          {/*  <div className="form-check notification-check">*/}
                          {/*    <input*/}
                          {/*      className="form-check-input"*/}
                          {/*      type="checkbox"*/}
                          {/*      value=""*/}
                          {/*      id="messages-notification-check01"*/}
                          {/*    />*/}
                          {/*    <label*/}
                          {/*      className="form-check-label"*/}
                          {/*      htmlFor="messages-notification-check01"*/}
                          {/*    ></label>*/}
                          {/*  </div>*/}
                          {/*</div>*/}
                        </div>
                      </div>
                    ))
                ) : (
                  <div className="text-center">
                    <span>You have no notifications.</span>
                  </div>
                )}
                {/*<div className="my-3 text-center">*/}
                {/*  <button*/}
                {/*    type="button"*/}
                {/*    className="btn btn-soft-success waves-effect waves-light"*/}
                {/*  >*/}
                {/*    View All Messages{" "}*/}
                {/*    <i className="ri-arrow-right-line align-middle"></i>*/}
                {/*  </button>*/}
                {/*</div>*/}
              </SimpleBar>
            </TabPane>
            <TabPane tabId="3" className="py-2 ps-2">
              <SimpleBar style={{ maxHeight: "300px" }} className="pe-2">
                {!isEmpty(
                  notificationOpenList?.filter(
                    (item) => item.NotificationType_Id === "1"
                  )
                ) ? (
                  notificationOpenList
                    ?.filter((item) => item.NotificationType_Id === "1")
                    ?.map((item, index) => (
                      <div
                        key={index}
                        className="text-reset notification-item d-block dropdown-item"
                      >
                        <div className="d-flex">
                          <img
                            src={item?.ImageUrl}
                            className="me-3 rounded-circle avatar-xs"
                            alt="user-pic"
                          />
                          <div className="flex-1">
                            <Link to={item?.LinkUrl} className="stretched-link">
                              <h6 className="mt-0 mb-1 fs-13 fw-semibold">
                                {item?.Title}
                              </h6>
                            </Link>
                            <div className="fs-13 text-muted">
                              <p className="mb-1">{item?.Description}</p>
                            </div>
                            <p className="mb-0 fs-11 fw-medium text-uppercase text-muted">
                              <span>
                                <i className="mdi mdi-clock-outline"></i>{" "}
                                <span>
                                  {handleTimeAgo(item?.CreatedDateTime)} ago
                                </span>
                              </span>
                            </p>
                          </div>
                          {/*<div className="px-2 fs-15">*/}
                          {/*  <div className="form-check notification-check">*/}
                          {/*    <input*/}
                          {/*      className="form-check-input"*/}
                          {/*      type="checkbox"*/}
                          {/*      value=""*/}
                          {/*      id="messages-notification-check01"*/}
                          {/*    />*/}
                          {/*    <label*/}
                          {/*      className="form-check-label"*/}
                          {/*      htmlFor="messages-notification-check01"*/}
                          {/*    ></label>*/}
                          {/*  </div>*/}
                          {/*</div>*/}
                        </div>
                      </div>
                    ))
                ) : (
                  <div className="text-center">
                    <span>You have no notifications.</span>
                  </div>
                )}
                {/*<div className="my-3 text-center">*/}
                {/*  <button*/}
                {/*    type="button"*/}
                {/*    className="btn btn-soft-success waves-effect waves-light"*/}
                {/*  >*/}
                {/*    View All Messages{" "}*/}
                {/*    <i className="ri-arrow-right-line align-middle"></i>*/}
                {/*  </button>*/}
                {/*</div>*/}
              </SimpleBar>
            </TabPane>
          </TabContent>
        </DropdownMenu>
      </Dropdown>
    </React.Fragment>
  );
};

export default NotificationDropdown;
